var ctrlopt = ctrlopt,
  site = site || {};

(function ($) {
  var apptBook = Drupal.appointmentBooking;
  var oab_params = Drupal.settings.globals_variables || {};
  var services_auto_redirect = oab_params.services_auto_redirect !== 'undefined' ? oab_params.services_auto_redirect : 0;

  /* Concrete View */
  apptBook.ServicesSelectSection = function (container) {
    apptBook.ServicesSelectSection.superclass.constructor.call(this);
    this.id = 'services';
    this.container = container;
    this.servContainer = container.find('.services-container');
    this.servRenutContainer = container.find('.services-renutrive');
    this.servRenutContent = this.servRenutContainer.find('.services-renutrive-content');
    this.servicesRenutriv = this.servRenutContainer.find('.service').css('display', 'none').detach();
    this.services = this.servContainer.find('.service').css('display', 'none').detach();
    this.isRenutriv = 0;
    this.bookBar = container.find('.book-now-bar');
    this.totTime = this.bookBar.find('.minutes');
    this.bookBtn = this.bookBar.find('.button');
    this.initialised = false;
    this.minLabel = container.attr('data-minutes-label');
    this.maxSelections = parseInt(container.attr('data-max-select'));
    this.maxAppointmentDuration = 60; // Default to 60 mins
    this.msOverlay = container.find('.appt-book-services-overlay').remove();
    // this.msOverlayClose = this.msOverlay.find('.overlay-close');
    this.jqBod = $('body');
    this.backTo = this.container.find('.back-to-link');
    this.boundRun = this.runBuild.bind(this);
  };

  ctrlopt.extend(apptBook.ServicesSelectSection, apptBook.AbstractSection);

  apptBook.ServicesSelectSection.prototype.buildServices = function () {
    if (!this.buildParams || !this.buildParams.counterId) {
      return;
    }

    var serviceSelections, cServices, selectedCounter, checkMaxSelection,
      serviceMap = {},
      myServices = $(),
      myRenutrivServices = $(),
      me = this;

    if (this.servRenutContainer && this.servRenutContainer[0]) {
      servRenutContainer = this.servRenutContainer.clone(),
      servRenutContent = servRenutContainer.find('.services-renutrive-content');
    }

    this.myServices = $();

    for (var i = 0, len = this.servicesData.length; i < len; i += 1) {
      var s = this.servicesData[i];

      serviceMap[s.id] = s;
    }

    this.counterId = this.buildParams.counterId;
    // check the max selection from CMS setting
    checkMaxSelection = parseInt(this.container.attr('data-max-select'));
    selectedCounter = this.model.getCounter(this.buildParams.counterId);
    this.maxAppointmentDuration = selectedCounter.max_appointment_duration;
    if (!checkMaxSelection) {
      // 0 in the BE means no limit. So, use an arbitrary high number in the case of 0
      this.maxSelections = selectedCounter.max_appointment_services ? selectedCounter.max_appointment_services : 99;
    }
    var max_selected = this.maxSelections;

    this.backTo.off('click').click(function (e) {
      var updateData = {
        sectionId: 'previous',
        params: {
          counterId: me.counterId,
          updateMode: me.updateMode
        }
      };

      me.model.update(updateData);
    });

    cServices = this.model.getCounterServices(this.counterId);
    if (cServices) {
      this.services.each(function () {
        var sdata, serv,
          $this = $(this),
          onlineContentId = $this.attr('data-content-id');

        minLabel = $this.attr('data-minutes-label');

        if (checkService(onlineContentId)) {
          sdata = me.model.getService(onlineContentId);
          if (sdata) {
            serv = $this.clone();
            serv.attr('data-total-duration', sdata.total_duration).find('.selection-time').text(sdata.total_duration + ' ' + minLabel);
            serv.attr('data-total-duration-with-padding', sdata.total_duration_with_padding);
            serv.attr('data-service-id', sdata.id);
            serv.find('.selection-selector').click(function (e) {
              var sText, stat,
                $this = $(this),
                icon = $this.find('.icon').remove(),
                par = $this.parents('.service'),
                dur = par.attr('data-total-duration');

              if ($this.hasClass('selected')) {
                sText = $this.attr('data-select-text');
                stat = 'not-selected';
                $this.removeClass('selected');
                par.removeClass('selected');
              } else {
                sText = $this.attr('data-selected-text');
                stat = 'selected';
                $this.removeClass('not-selected');
                par.removeClass('not-selected');
              }

              $this.addClass(stat).html(sText).prepend(icon);
              par.attr('data-status', stat).addClass(stat);
              updateBar(par);
              if ($this.hasClass('selected') && (serviceSelections.length == max_selected) && services_auto_redirect) {
                checkServices($this);
              }
            });
          }

          me.myServices = me.myServices.add(serv);
        }
      });

      if (this.servRenutContainer && this.servRenutContainer[0]) {
        this.servicesRenutriv.each(function () {
          var sdata, serv,
            $this = $(this),
            onlineContentId = $this.attr('data-content-id');

          minLabel = $this.attr('data-minutes-label');

          if (checkService(onlineContentId)) {
            sdata = me.model.getService(onlineContentId);
            me.isRenutriv = 1;
            if (sdata) {
              serv = $this.clone();
              serv.attr('data-total-duration', sdata.total_duration).find('.selection-time').text(sdata.total_duration + ' ' + minLabel);
              serv.attr('data-total-duration-with-padding', sdata.total_duration_with_padding);
              serv.attr('data-service-id', sdata.id);
              serv.find('.selection-selector').click(function (e) {
                var sText, stat,
                  $this = $(this),
                  icon = $this.find('.icon').remove(),
                  par = $this.parents('.service'),
                  dur = par.attr('data-total-duration');

                if ($this.hasClass('selected')) {
                  sText = $this.attr('data-select-text');
                  stat = 'not-selected';
                  $this.removeClass('selected');
                  par.removeClass('selected');
                } else {
                  sText = $this.attr('data-selected-text');
                  stat = 'selected';
                  $this.removeClass('not-selected');
                  par.removeClass('not-selected');
                }

                $this.addClass(stat).html(sText).prepend(icon);
                par.attr('data-status', stat).addClass(stat);
                updateBar(par);
                if ($this.hasClass('selected') && (serviceSelections.length == max_selected) && services_auto_redirect) {
                  checkServices($this);
                }
              });
            }

            myRenutrivServices = myRenutrivServices.add(serv);
          }
        });
      }

      me.servRenutContainer.detach();
      this.servContainer.append(this.myServices);
      if (this.servRenutContainer && this.servRenutContainer[0] && this.isRenutriv) {
        servRenutContent.append(myRenutrivServices);
        this.servContainer.after(servRenutContainer);
        this.servRenutContainer = this.container.find('.services-renutrive');
        this.servRenutContent = this.servRenutContainer.find('.services-renutrive-content');
        myRenutrivServices.css('display', 'block');
        // Resetting the isRenutriv variable
        this.isRenutriv = 0;
      }
      this.myServices.css('display', 'block');

      updateBar();
      this.bookBtn.off('click');
      this.bookBtn.click(function (e) {
        checkServices(this);
      });

      this.myServices.each(function () {
        var serv = $(this),
          sHead = serv.find('.service-head'),
          closeH = sHead.height(),
          openH = serv.height();

        serv.attr('data-close', closeH);
        serv.attr('data-open', openH);
        serv.css('height', closeH + 'px');

        sHead.click(function (e) {
          var $this = $(this),
            myServ = $this.parents('.service');

          if (myServ.hasClass('expanded')) {
            closeServ(myServ, $this);
          } else {
            openServ(myServ, $this);
          }

          e.preventDefault();
        });
      });

      if (this.servRenutContainer && this.servRenutContainer[0]) {
        this.servRenutContainer.each(function () {
          var serv = $(this),
            sHead = serv.find('.services-renutrive-header'),
            closeH = sHead.height(),
            openH = serv.height();

          serv.attr('data-close', closeH);
          serv.attr('data-open', openH);
          serv.css('height', closeH + 'px');

          sHead.click(function (e) {
            var $this = $(this),
              myServ = $this.parents('.services-renutrive');

            if (myServ.hasClass('expanded')) {
              closeServ(myServ, $this);
            } else {
              openServ(myServ, $this);
            }

            e.preventDefault();
          });
        });
        // reset renutriv container after coming back from next step
        var renServ = $('.services-renutrive');

        renServ.removeClass('expanded');
      }
    }

    function checkServices(currentElement) {
      var updateData,
        anStr = serviceSelections.length + 'Apt',
        $this = $(currentElement);

      if ($this.hasClass('disabled')) {
        return;
      }
      var serviceNames = serviceSelections.map(function (element) {
        return element.serviceName.trim();
      }).join('|');

      site.track.evtLink({
        event_name: 'appointmentBooking_Service',
        event_category: 'appointment booking',
        event_action: 'services selected',
        event_label: serviceNames
      });

      updateData = {
        sectionId: 'next',
        params: {
          counterId: me.counterId,
          services: serviceSelections,
          updateMode: me.updateMode
        }
      };
      me.model.update(updateData);
    }
    function checkService(id) {
      if (cServices) {
        for (var i = 0, len = cServices.length; i < len; i += 1) {
          var sId = cServices[i];

          if (id === serviceMap[sId].online_content_id) {
            return true;
          }
        }
      }

      return false;
    }

    function updateBar(lastSelection) {
      var totalTime = 0;
      var sel, selBtn, sText, icon,
        selected = me.servContainer.children('.selected');

      if (me.servRenutContainer && me.servRenutContainer[0]) {
        var selectedRenut = me.servRenutContent.children('.selected');

        $.merge(selected, selectedRenut);
      }

      serviceSelections = [];
      var that = this;

      that.totalSelectedServiceTime = 0;
      selected.each(function (index, value) {
        that.totalSelectedServiceTime += parseInt($(value).attr('data-total-duration-with-padding'));
      });

      if (selected.length > me.maxSelections || (lastSelection && that.totalSelectedServiceTime > me.maxAppointmentDuration)) {
        me.jqBod.prepend(me.msOverlay);
        me.msOverlay.css('display', 'block').click(function (e) {
          e.preventDefault();
          me.msOverlay.remove();
        });

        if (lastSelection && (selected.length === (me.maxSelections + 1) || that.totalSelectedServiceTime > me.maxAppointmentDuration)) {
          sel = lastSelection.removeClass('selected').attr('data-status', 'not-selected');
          selBtn = sel.find('.selection-selector').removeClass('selected').addClass('not-selected');
          sText = selBtn.attr('data-select-text');
          selBtn.text(sText);
        } else {
          for (var i = me.maxSelections, len = selected.length; i < len; i += 1) {
            sel = selected.eq(i).removeClass('selected').attr('data-status', 'not-selected');
            selBtn = sel.find('.selection-selector').removeClass('selected').addClass('not-selected');
            icon = selBtn.find('.icon').remove();
            sText = selBtn.attr('data-select-text');
            selBtn.html(sText).prepend(icon);
          }
        }

        updateBar();

        return;
      }

      selected.each(function (i) {
        var $this = $(this),
          time = parseInt($this.attr('data-total-duration')),
          timeWithPadding = parseInt($this.attr('data-total-duration-with-padding')),
          serviceId = parseInt($this.attr('data-service-id')),
          serviceName = $this.find('.service-title').text();

        totalTime += time;
        serviceSelections.push({
          serviceId: serviceId,
          serviceDurationWithPadding: timeWithPadding,
          serviceDuration: time,
          serviceName: serviceName
        });
      });

      if (totalTime > 0) {
        me.bookBtn.removeClass('disabled');
      } else {
        me.bookBtn.addClass('disabled');
      }
      me.totTime.text(totalTime + ' ' + me.minLabel);
    }

    function openServ(serv, servHead) {
      var h;

      if (serv.hasClass('selected') || serv.hasClass('expanded') || servHead.hasClass('disabled')) {
        return;
      }
      servHead.addClass('disabled');
      h = serv.attr('data-open');

      me.myServices.filter('.expanded').each(function () {
        var $t = $(this),
          sH = $t.find('.service-head');

        closeServ($t, sH);
      });

      serv.addClass('expanded');
      serv.animate({ height: h + 'px' }, 700, function () {
        serv.css('height', 'auto');
        servHead.removeClass('disabled');
      });
    }

    function closeServ(serv, servHead) {
      var h;

      if (serv.hasClass('selected') || !serv.hasClass('expanded') || servHead.hasClass('disabled')) {
        return;
      }
      servHead.addClass('disabled');
      h = serv.attr('data-close');
      serv.animate({ height: h + 'px' }, 700, function () {
        servHead.removeClass('disabled');
        serv.removeClass('expanded');
      });
    }
  };

  apptBook.ServicesSelectSection.prototype.runBuild = function () {
    this.buildServices();
  };

  apptBook.ServicesSelectSection.prototype.onUpdate = function (data) {
    var aPgName = document.title + ' - Services Select',
      hasVirtual = localStorage.getItem('virtual_oab') || 0;

    if (parseInt(hasVirtual)) {
      this.container.find('.virtual-oab').removeClass('hidden');
      this.container.find('.physical-oab').addClass('hidden');
    } else {
      this.container.find('.physical-oab').removeClass('hidden');
      this.container.find('.virtual-oab').addClass('hidden');
    }

    if (data.sectionId === this.id) {
      this.buildParams = data.params;
      if (data.params.updateMode) {
        this.updateMode = true;
      } else {
        this.updateMode = false;
      }
      /* this.countersData = this.model.getCounters();*/
      this.servicesData = this.model.getServices();
      this.servContainer.empty();
      if (this.servRenutContainer && this.servRenutContainer[0]) {
        this.servRenutContent.empty();
      }
      if (this.myServices && this.myServices.length) {
        this.myServices.remove();
      }
      this.myServices = null;
      apptBook.sectionManager.on('transition_in_start', this.boundRun);
    } else {
      apptBook.sectionManager.off('transition_in_start', this.boundRun);
    }
  };

  Drupal.behaviors.apptBookServices = {
    attach: function (context) {
      var view = new apptBook.ServicesSelectSection($('#services'));

      view.setModel(apptBook.sectionModel).startObserving();
    }
  };
})(jQuery);
